var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#27A376",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_12369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6995 25.522H24.5051V27.3798H23.3332V22.6914H20.5859V27.3798H19.4141V22.6914H16.6668V27.3798H15.4949V25.522H11.3005V27.3798H10V28.5517H30V27.3798H28.6995V25.522Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1374 17.2771C16.5957 16.7451 16.2011 16.064 16.021 15.3008H10.7916L10 16.0924V17.2771H10.1286H17.1374Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9666 17.2767H20.0297C21.6231 17.2596 22.9142 15.9587 22.9142 14.3614C22.9142 12.7535 21.6061 11.4453 19.9981 11.4453C18.3902 11.4453 17.082 12.7535 17.082 14.3614C17.082 15.9587 18.3732 17.2596 19.9666 17.2767ZM18.8262 13.1493H19.9981V14.3211H21.17V15.493H19.9981V14.3211H18.8262V13.1493Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6998 24.3507V18.4492H11.3008V24.3507H15.4952V21.5201H24.5054V24.3507H28.6998Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2091 15.3008H23.9796C23.7996 16.0639 23.405 16.7451 22.8633 17.2771H29.872H30.0007V16.0924L29.2091 15.3008Z",
    fill: "#27A376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_12369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClub);
export default __webpack_public_path__ + "static/media/club.2e3b44d53058bcf3134be627fee40d7b.svg";
export { ForwardRef as ReactComponent };